module.exports = __webpack_public_path__ + "img/vice_banner.6ecd23fa.png";